import { lazy, Suspense } from 'react';
import LazyLoading from '../../components/LazyLoading';

export const Lazy = lazy(
  () => import(/* webpackChunkName: 'Buy Discount Card' */ './index'),
);

export default function BuyDiscountCard() {
  return (
    <Suspense fallback={<LazyLoading />}>
      <Lazy />
    </Suspense>
  );
}
